import { useMutation } from 'react-query';
import firebase from 'firebase/app';
import { REST_MNGT_ENDPOINT } from 'src/config';

const useMutationRunRestaurantClosedProcedure = () => {
  return useMutation(
    `run_restaurant_open_procedure`,
    async (rest_id) => {
      const idToken = await firebase.auth().currentUser?.getIdToken();
      const response = await fetch(
        `${REST_MNGT_ENDPOINT}/runRestaurantClosedProcedure?rest_id=${rest_id}`,
        {
          headers: idToken ? { Authorization: `Bearer ${idToken}` } : {},
        }
      );

      if (!response.ok) {
        console.error(
          'error during calling RunRestaurantClosedProcedure ',
          response
        );
        throw new Error(
          `runRestaurantClosedProcedure failed with status ${response.status}`
        );
      }

      return response.json();
    },
    { retry: 5 }
  );
};

export default useMutationRunRestaurantClosedProcedure;
